import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo } from "react";
import { useAsignaturas } from "../../../../context/SuperAdmin/OASContexts/AsignaturasContext";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import { AsignaturasRow } from "./AsignaturasRow";

const AsignaturasTable = () => {
  const {
    asignaturas,
    setSelectedAsignaturas,
    selectedAsignaturas,
    searchText,
  } = useAsignaturas();

  const selectAll = () => {
    setSelectedAsignaturas(
      filteredNiveles.map((asignatura) => asignatura.id_asignatura)
    );
  };

  // Manejar selección/deselección de una asignatura
  const handleSelect = (id: string) => {
    setSelectedAsignaturas((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Filtro de asignaturas por búsqueda
  const filteredNiveles = useMemo(() => {
    const normalizedSearch = searchText.toLowerCase().trim();
    return asignaturas.filter((u) =>
      u.nombre.toLowerCase().includes(normalizedSearch)
    );
  }, [asignaturas, searchText]);

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedAsignaturas.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedAsignaturas([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Nombre
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Fecha de creación
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Acciones
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredNiveles.length > 0 ? (
            filteredNiveles.map((item, index) => (
              <AsignaturasRow
                asignatura={item}
                i={index + 1}
                key={item.id_asignatura}
                handleSelect={handleSelect}
                isSelected={selectedAsignaturas.includes(item.id_asignatura)}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AsignaturasTable;
